export enum MailingAPIRoutes {
    GET_HISTORY_USERS = "auth:users:query",
    GET_SUBSIDIARIES = "subsidiary:query",
    GET_MAILING_LISTS = "config:settings:mail",
    GET_MAILING_LIST = "config:settings:mail",
    GET_MAILING_LISTS_TYPES = "config:settings:mail:types",
    ADD_MAILING_LISTS = "config:settings:mail:create",
    EDIT_MAILING_LIST = "config:settings:mail:update"
}
